<template>
  <div id="sig-container" class="full form-horizontal">
    <div class="loader" v-if="loading">
      <i class="fa fa-spinner fa-2x fa-spin text-info"></i>
    </div>
    <contacto />
    <table-component :data="historico_gestion" pagination>
      <table-column
        slot="label"
        :label="'Asesor'"
        v-bind:value="'usuario.username'"
      ></table-column>
      <table-column
        slot="label"
        :label="'Fecha gestión'"
        v-bind:value="'hora_inicio'"
        :filter="'formatDate'"
      ></table-column>
      <table-column
        slot="label"
        :label="'Subtipo gestión'"
        v-bind:value="'sub_tipo_gestion.descripcion'"
      ></table-column>
      <table-column
        slot="label"
        :label="'Origen'"
        v-bind:value="'origen'"
      ></table-column>
      <table-column
        slot="label"
        :label="'Celular'"
        v-bind:value="'telefono'"
      ></table-column>
      <table-column
        slot="label"
        :label="'Número de Obligacion'"
        v-bind:value="'informacion_adicional.pagare'"
      ></table-column>
      <table-column
        slot="label"
        :label="'Observación'"
        v-bind:value="'observacion'"
        width="600"
      ></table-column>
    </table-component>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
export default {
  name: "HistoricoGestion",
  data: () => {
    return {};
  },
  computed: {
    ...mapGetters({
      historico_gestion: "deudor/historico_gestion",
      loading: "loading",
    }),
  },
  components: {
    TableComponent: () => import("@@/components/table/TableComponent"),
    TableColumn: () => import("@@/components/table/TableColumn"),
    Contacto: () => import("@/views/Contacto.vue"),
  },
  methods: {
    getHistorico(deudor_id) {
      this.$store.dispatch("deudor/refresh_historico_gestion", []);
      this.$store
        .dispatch("index", {
          endpoint: "gestion",
          params: {
            deudor_id: deudor_id,
            paginar: false,
          },
        })
        .then((response) => {
          if (response.datos.length > 0) {
            let datos = [];

            response.datos.forEach((element) => {
              if (typeof element.informacion_adicional == "string") {
                element.informacion_adicional = JSON.parse(
                  element.informacion_adicional
                );
                datos.push(element);
              }
            });

            this.$store.dispatch("deudor/refresh_historico_gestion", datos);
          } else {
            this.$notify({
              title: "Advertencia!",
              type: "warning",
              content:
                "No se encontró información con el documento " + deudor_id,
            });
          }
        })
        .catch(() => {
          this.$notify({
            title: "Advertencia!",
            type: "danger",
            content: "Se ha presentado un error realizando su consulta",
          });
        });
    },
  },
  mounted() {
    this.getHistorico(this.$route.params.deudor_id);
  },
};
</script>
